import { useUpdateAccount } from 'modules/sendingPlatforms/hooks';
import { useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useModalsContext } from '../../../contexts';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../types';

const { NAME } = ESP_ACCOUNT_PAYLOAD_FIELDS;

type Props = {
  children: React.ReactNode;
  onSubmit: (data: Record<string, string>) => void;
};

export const EditModalRHF = ({ children, onSubmit }: Props) => {
  const { hideModal } = useModalsContext();
  const { isLoading } = useUpdateAccount();
  const {
    handleSubmit,
    formState: { isValid, isDirty, defaultValues },
  } = useFormContext();

  const initialName = (defaultValues as Record<string, string>)[NAME];

  return (
    <Modal
      id="edit-account-modal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Edit {initialName}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <PrimaryButton
          isDisabled={!(isValid && isDirty)}
          isLoading={isLoading}
          onClick={handleSubmit(onSubmit)}
          size={BUTTON_SIZES.LARGE}
        >
          Save account
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
